import { FunctionComponent, useContext } from 'react';
import { Typography } from '@mui/material';
import { AppContext } from '../../providers/AppContext';
import useWindowDimensions from '../../hooks/dimension';

interface GitHubStatsProps {
    handleDrag: any;
    handleDrop: any;
    id: any;
}

const GitHubStats: FunctionComponent<GitHubStatsProps> = (props: GitHubStatsProps) => {

    const { username } = useContext(AppContext);
    const { height, width } = useWindowDimensions();


    return (
        <div
            id={props.id}
            draggable={true}
            onDragStart={props.handleDrag}
            onDragOver={(e: any) => e.preventDefault()}
            onDrop={(e) => props.handleDrop(e, true)}
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                marginTop: 8
            }}
        >
            <Typography variant='h5' style={{
                marginBottom: 8,
            }}>GitHub Stats</Typography>

            {
                username ?
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'flex-start'
                    }}>
                        <img src={`https://github-readme-stats.vercel.app/api/top-langs?username=${username}&card_width=${width && width < 800 ? width - 130 : 300}`} alt={username} />
                        <br />
                        <img src={`https://github-readme-stats.vercel.app/api?username=${username}&card_width=${width && width < 800 ? width - 130 : 500}&hide_rank=${width && width < 800 ? true : false}`} alt={username} />
                    </div>
                    : <Typography> Please fill the github username first </Typography>
            }
        </div>
    );
}

export default GitHubStats;